import { render, staticRenderFns } from "./FaturasPendentes.vue?vue&type=template&id=34d61ee0&scoped=true"
import script from "./FaturasPendentes.vue?vue&type=script&lang=js"
export * from "./FaturasPendentes.vue?vue&type=script&lang=js"
import style0 from "./FaturasPendentes.vue?vue&type=style&index=0&id=34d61ee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d61ee0",
  null
  
)

export default component.exports